<template>
  <div>
    <b-modal
      id="isshowSummary"
      size=""
      centered
      hide-header
      modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
      hide-footer
      class="overflow-y-hidden"
    >
      <div class="flex justify-between">
        <div class="text-black fsize25px font-medium header-font">
          <h1>Add Summary</h1>
        </div>
        <feather-icon @click="handleClose" icon="XIcon" />
      </div>
      <div class="border-review-modal space-border mt-5">
        <!-- <div class="text-center fsize20px font-medium text-opax">
          <h1>Experience with our Caretaker!</h1>
        </div> -->

        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <label for="">Activity form</label>
          <div>
            <el-input
              type="textarea"
              placeholder="Leave a message,if you want"
              width="50px"
              rows="5"
              v-model="summary"
              :rules="{ required: true }"
              class="justify-center bg-f3f3f3"
            >
            </el-input>
          </div>

          <div class="mt-5 flex justify-center">
            <b-button variant="primary" @click="handleSubmit">Save</b-button>
          </div>
        </el-form>
      </div>
    </b-modal>

    <div>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="get_completedbooking.record"
      >
        <el-table-column
          label="Sr. No"
          type="index"
          :index="indexMethod"
          width="80px"
        ></el-table-column>

        <el-table-column label="Name" min-width="140px" prop="name" sortable>
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm">
                  {{ row.userId.firstname + " " + row.userId.lastname }}
                </span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column
          label="Phone No."
          prop="mobile"
          min-width="160px"
          sortable
        >
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm"
                  >{{ row.userId.mobile }}
                </span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column
          label="Email ID"
          prop="email"
          min-width="180px"
          sortable
        >
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm">
                  {{ row.userId.email }}
                </span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column label="Session Id" min-width="190px">
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm"
                  >{{ row._id }}
                </span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column label="Status" min-width="100px">
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm"
                  >{{ row.status }}
                </span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>
        <el-table-column label="Summary" min-width="190px">
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <b-media-body>
                <span class="font-medium name mb-0 text-sm"
                  >{{ row.summary }}
                </span>
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>
        <el-table-column label="Add Summary" min-width="190px">
          <template v-slot="{ row }">
            <span class="font-medium name mb-0 text-sm" v-b-modal.isshowSummary>
              <b-button variant="primary" @click="addSummary(row._id)"
                >Add
              </b-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          @change="handlePageChange"
          v-model="currentPage"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import { mapState } from "vuex";
import Newproject from "../../../../volunteer-view/layouts/components/Newproject";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      Newproject,
      completedBooking: [],
      summary: "",
      sessionId: "",
      currentPage: 1,
      perPage: 10,
      total_row: 1,
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async init() {
      const payload = {
        _id: this.get_volunteerbyuserId[0]._id,
        limit: 10,
        offset: this.currentPage - 1,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("respitecare/get_completedbooking", payload);
        this.total_row = this.get_completedbooking.totalCount;
        loader.close();
      } catch (err) {
        loader.close();
        console.log(err);
      }
    },
    addSummary(id) {
      this.$bvModal.show("isshowSummary");
      this.sessionId = id;
    },
    async handleSubmit(id) {
      let payload = {
        _id: this.sessionId,
        summary: this.summary,
      };
      let loader = this.$loading();

      try {
        await this.$store.dispatch("respitecare/editbooking", payload);
        await this.$store.dispatch("respitecare/get_completedbooking", {
          _id: this.get_volunteerbyuserId[0]._id,
        });
        // this.init();
        this.$bvModal.hide("isshowSummary");
        this.summary = "";
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_completedbooking: "get_completedbooking",
      get_volunteerbyuserId: "get_volunteerbyuserId",
    }),
  },
  mounted() {
    this.init();
  },
};
// {role:"student"}
</script>
